import React, { FunctionComponent } from 'react';
import { Setup } from './components';
import { PackI } from '@/containers/ActionServiceV2/utils';
import { Column } from '@/components';

type PacksProps = {
  price: number;
  isForSubscriptionEnabled: boolean;
  packs?: PackI[];
  addPack: (pack: PackI) => void;
  deletePack: (id: number) => void;
  isStripeConnected: boolean;
};

export const Packs: FunctionComponent<PacksProps> = ({
  price,
  isForSubscriptionEnabled,
  packs,
  addPack,
  deletePack,
  isStripeConnected
}) => (
  <Column justify="space-between">
    <Setup
      price={price}
      isForSubscriptionEnabled={isForSubscriptionEnabled}
      packs={packs}
      deletePack={deletePack}
      addPack={addPack}
      isStripeConnected={isStripeConnected}
    />
  </Column>
);
